'use client'

import { useRouter } from 'next/navigation'
import { PricingTable } from '@/components/PricingTable'

export function PricingSignUpSection() {
  const router = useRouter()

  return <PricingTable signUpMode onSignUp={() => router.push('/sign-up')} />
}
